import {ButtonDetail, ButtonApproval} from "../../component/common/Button"
import {getRegTypeBadge, getValidObjBadge} from "../common/BaseUtil"

export function JobCardAdmin(props) {
    return (
        <div class="card" key={props.index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{props.object.objTitle}</h4>
                <h6 class="text-muted card-subtitle mb-2" style={{ fontFamily: 'Nanum Gothic' }}>회사:{props.object.cpName}</h6>
                <p class="card-text">{props.object.jobDetail.replace( /(<([^>]+)>)/ig, '')}</p>
                <p class="card-text">{getRegTypeBadge(props.object.regType)}</p>
                <p class="card-text">{getValidObjBadge(props.object.validObj)}</p>
                <ButtonDetail id={props.object.id} url={"/job?id="} returnTo={props.returnTo}/>
                <ButtonApproval id={props.object.id} objTitle={props.object.objTitle} url={"/post/object/approval"}/>
            </div>
        </div> 
    );
}